import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, userService } from "../../services";
import {
  downloadBase64File,
  getLocalStorageItem,
  setLocalStorageItem,
  setSessionStorageItem,
} from "../../system";
import {
  StorageKeys,
  userConstants,
  loginConstants,
  viewPathConstants,
  adminUserConstants,
  translationConstants,
  registrationConstants,
  globalSystemConstants,
  UserVerificationApprovalStatus,
  contentType,
} from "../../constants";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: null,
  filterQuery: null,
  search: null,
};

export const getUsers = (GetData) => {
  return (dispatch) => {
    dispatch(
      custom(userConstants.USERS_DATA, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .getUsers(GetData)
      .then((response) => {
        const { page, pageData } = response;
        dispatch(success({ page, pageData }, userConstants.USERS_DATA));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            userConstants.USERS_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getApprovals = (GetData) => {
  return (dispatch) => {
    dispatch(
      custom(
        userConstants.APPROVALS_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    userService
      .getApprovals(GetData)
      .then((response) => {
        const { page, pageData } = response;
        dispatch(success({ page, pageData }, userConstants.APPROVALS_DATA));
      })
      .catch((error) =>
        ToastifyService.showError(i18next.t(translationConstants.noDataFound))
      )
      .finally(() => {
        dispatch(
          custom(
            userConstants.APPROVALS_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getUserById = (userId) => {
  return (dispatch) => {
    dispatch(
      custom(
        userConstants.APPROVALS_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    userService
      .getUserById(userId)
      .then((response) => {
        dispatch(success(response, userConstants.USER_DATA));
      })
      .catch((error) => {
        ToastifyService.showError(i18next.t(translationConstants.noDataFound));
      })
      .finally(() => {
        dispatch(
          custom(
            userConstants.APPROVALS_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getApprovalUserById = (userId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .getApprovalUserById(userId)
      .then((response) => {
        dispatch(success(response, userConstants.APPROVAL_USER_DATA));
      })
      .catch((error) => {
        dispatch(UserActions.ChangeUserApprovalModalStatus(false));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const getUserSportsById = (userId) => {
  return (dispatch) => {
    userService
      .getUserSportsById(userId)
      .then((response) => {
        dispatch(success(response, userConstants.USER_SPORTS));
      })
      .catch((error) => {});
  };
};

export const certifiedPractitioner = (
  certifiedPractitionerDocs,
  userID,
  navigate,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .certifiedPractioner(certifiedPractitionerDocs, userID)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(success(false, userConstants.OPEN_MODAL));
        dispatch(success(3, loginConstants.UNDER_REVIEW));
        if (getLocalStorageItem(StorageKeys.userSportDocumentStatus)) {
          setLocalStorageItem(StorageKeys.userSportDocumentStatus, 3);
        } else {
          setLocalStorageItem(StorageKeys.userSportDocumentStatus, 3);
        }
        const userDetail = { status: 6, tokenExpired: false };
        dispatch(
          success(userDetail, registrationConstants.REGISTRATION_SUCCESS)
        );
        navigate(viewPathConstants.NOTIFICATION);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const updateUser = (userUpdatedData, callback) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    userService
      .updateUser(userUpdatedData)
      .then((response) => {
        const message = i18next.t(translationConstants.userUpdateSuccessfully);
        ToastifyService.showSuccess(message);
        dispatch(UserActions.OpenModal(false));
        dispatch(callback);
      })
      .catch((error) => {
        if (Array.isArray(error[1])) {
          const errorMessage = error[1].join("\n");
          ToastifyService.showError(errorMessage);
        } else {
          ToastifyService.showError(error);
        }
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

export const approvedCertificate = (approvedData, gridState, userID) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .approvedCertificate(approvedData)
      .then((response) => {
        const message = i18next.t(
          translationConstants.userStateUpdateSuccessfully
        );
        ToastifyService.showSuccess(message);
        // dispatch(UserActions.ChangeUserApprovalModalStatus(false));
        dispatch(UserActions.getApprovalUserById(userID));
        dispatch(UserActions.getApprovals(gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const approvedDocuments = (DocumentStatus, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .approvedDocuments(DocumentStatus)
      .then((response) => {
        const message = i18next.t(
          translationConstants.userStateUpdateSuccessfully
        );
        ToastifyService.showSuccess(message);
        dispatch(UserActions.ChangeUserApprovalModalStatus(false));
        dispatch(UserActions.getApprovals(gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const RejectDocuments = () => {
  return (dispatch) => {
    userService
      .RejectDocuments()
      .then(() => {
        ToastifyService.showSuccess(translationConstants.DOCUMENT_REJECTED);
        dispatch(UserActions.ChangeUserApprovalModalStatus(false));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

export const OpenModal = (value) => {
  return (dispatch) => {
    dispatch(success(value, userConstants.OPEN_MODAL));
  };
};
export const OpenAppRejModal = (value) => {
  return (dispatch) => {
    dispatch(success(value, userConstants.OPEN_APPREJ_MODAL));
  };
};

export const ChangeUserApprovalModalStatus = (value) => {
  return (dispatch) => {
    try {
      dispatch(custom(value, userConstants.USER_APPROVAL_VIEW_MODAL));
    } catch (error) {
      ToastifyService.showError(error);
    }
  };
};

export const getAdminUserById = (userId) => {
  return (dispatch) => {
    userService
      .getAdminUserById(userId)
      .then((response) =>
        dispatch(success(response, adminUserConstants.GET_ADMIN_USER_BY_ID))
      )
      .catch(() => ToastifyService.showError(translationConstants.noDataFound));
  };
};

export const getAdminUsers = (gridData) => {
  return (dispatch) => {
    dispatch(
      custom(
        adminUserConstants.ADMIN_USERS_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    userService
      .getAdminUsers(gridData)
      .then((response) =>
        dispatch(success(response, adminUserConstants.ADMIN_USERS_DATA))
      )
      .catch((error) =>
        ToastifyService.showError(translationConstants.noDataFound)
      )
      .finally(() => {
        dispatch(
          custom(
            adminUserConstants.ADMIN_USERS_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const createAdminUser = (data) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .createAdminUser(data)
      .then((response) => {
        if (response) {
          dispatch(getAdminUsers(gridData));
          ToastifyService.showSuccess(
            i18next.t(translationConstants.DONE_SUCCESSFULLY)
          );
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

export const updateAdminUser = (updatedData, gridData) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .updateAdminUser(updatedData)
      .then((response) => {
        if (response) {
          dispatch(getAdminUsers(gridData));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

export const updateAdminUserStatus = (data, callback) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .updateAdminUserStatus(data)
      .then((response) => {
        if (response) {
          dispatch(callback);
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const deleteAdminUserById = (userId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .deleteAdminUser(userId)
      .then((response) => {
        if (response) {
          dispatch(getAdminUsers(gridData));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const becomeInstructor = (docs, userID, navigate, onSuccess) => {
  return async (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .becomeInstructor(docs, userID)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(success(false, userConstants.OPEN_MODAL));
        dispatch(
          success(
            UserVerificationApprovalStatus.Pending,
            loginConstants.UNDER_REVIEW
          )
        );
        if (getLocalStorageItem(StorageKeys.instructorStatus)) {
          setLocalStorageItem(
            StorageKeys.instructorStatus,
            UserVerificationApprovalStatus.Pending
          );
        } else {
          setLocalStorageItem(
            StorageKeys.instructorStatus,
            UserVerificationApprovalStatus.Pending
          );
        }
        const userDetail = { status: 6, tokenExpired: false };
        dispatch(
          success(userDetail, registrationConstants.REGISTRATION_SUCCESS)
        );
        navigate(viewPathConstants.NOTIFICATION);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const updateUserStatusWithCallback = (data, callback) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .updateAdminUserStatus(data)
      .then((response) => {
        if (response) {
          dispatch(callback);
          dispatch(UserActions.getUserById(data.userId));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const exportUserData = (gridState, requestType) => {
  return (dispatch) => {
    userService
      .exportUserData(gridState, requestType)
      .then((response) => {
        downloadBase64File(
          response.content,
          contentType.CSV,
          response.fileName
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

const becomeMember = (checkout, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .becomeMember(checkout)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const cancelMembership = (systemUserId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .cancelMembership(systemUserId)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const becomeMemberWithSavedCard = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    userService
      .becomeMemberWithSavedCard(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const setQualificationFormState = (data) => {
  return (dispatch) => {
    dispatch(custom(data, userConstants.SET_QUALIFICATION_FORM_STATE));
  };
};

export const UserActions = {
  getUsers,
  getApprovals,
  certifiedPractitioner,
  OpenModal,
  getUserById,
  updateUser,
  approvedCertificate,
  approvedDocuments,
  RejectDocuments,
  getApprovalUserById,
  OpenAppRejModal,
  ChangeUserApprovalModalStatus,
  deleteAdminUserById,
  updateAdminUser,
  createAdminUser,
  getAdminUsers,
  getAdminUserById,
  updateAdminUserStatus,
  becomeInstructor,
  updateUserStatusWithCallback,
  exportUserData,
  getUserSportsById,
  becomeMember,
  cancelMembership,
  becomeMemberWithSavedCard,
  setQualificationFormState,
};
